(function () {
  'use strict';

  var btn = document.querySelector('[data-luxe-discover]');
  if (!btn) return;
  var hero = btn.closest('.luxe-hero');
  var panel = hero && hero.querySelector('[data-luxe-details]');
  if (!hero || !panel) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SHIFT_MS = reduce ? 0 : 900;
  var FADE_MS = reduce ? 0 : 450;

  var open = false;
  var timer = 0;

  var mobile = window.matchMedia('(max-width: 820px)');

  function syncStatic() {
    if (mobile.matches) {
      panel.removeAttribute('aria-hidden');
    } else if (!open) {
      panel.setAttribute('aria-hidden', 'true');
    }
  }
  syncStatic();
  if (mobile.addEventListener) mobile.addEventListener('change', syncStatic);
  else if (mobile.addListener) mobile.addListener(syncStatic);

  function clearTimer() {
    if (timer) { window.clearTimeout(timer); timer = 0; }
  }

  // The panel is sized to fit without scrolling; only when the copy genuinely
  // overruns its height cap does it get a visible scrollbar, and with it the
  // sticky × (the Discover button then stops doubling as a close control).
  // Mobile lays the panel out statically with no cap, so it never applies.
  var closeBtn = panel.querySelector('[data-ld-close]');

  function syncScrollable() {
    if (mobile.matches) {
      panel.classList.remove('is-scrollable');
      hero.classList.remove('is-details-scrollable');
      return;
    }
    var overflows = panel.scrollHeight - panel.clientHeight > 1;
    panel.classList.toggle('is-scrollable', overflows);
    hero.classList.toggle('is-details-scrollable', overflows);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      setOpen(false);
      btn.focus();
    });
  }

  var resizeTimer = 0;
  window.addEventListener('resize', function () {
    if (resizeTimer) window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(syncScrollable, 150);
  }, { passive: true });

  if (mobile.addEventListener) mobile.addEventListener('change', syncScrollable);
  else if (mobile.addListener) mobile.addListener(syncScrollable);

  // Measured once up front — the panel is laid out (just transparent and
  // pointer-inert) before it opens, so scrollHeight is already meaningful.
  syncScrollable();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncScrollable);

  function setOpen(next) {
    if (next === open) return;
    open = next;
    clearTimer();

    btn.setAttribute('aria-expanded', String(open));
    btn.setAttribute('aria-label', open ? 'Close details' : 'Discover details');
    if (!mobile.matches) panel.setAttribute('aria-hidden', String(!open));

    if (open) {
      syncScrollable();
      hero.classList.add('is-shifting');
      if (SHIFT_MS === 0) {
        hero.classList.add('is-panel-open');
      } else {
        timer = window.setTimeout(function () {
          hero.classList.add('is-panel-open');
        }, SHIFT_MS);
      }
    } else {
      hero.classList.remove('is-panel-open');
      if (FADE_MS === 0) {
        hero.classList.remove('is-shifting');
      } else {
        timer = window.setTimeout(function () {
          hero.classList.remove('is-shifting');
        }, FADE_MS);
      }
    }
  }

  btn.addEventListener('click', function () { setOpen(!open); });

  document.addEventListener('keydown', function (e) {
    if (open && (e.key === 'Escape' || e.key === 'Esc')) {
      setOpen(false);
      btn.focus();
    }
  });

  var swatches = panel.querySelectorAll('.ld__swatch');
  for (var i = 0; i < swatches.length; i++) {
    swatches[i].addEventListener('click', function () {
      for (var j = 0; j < swatches.length; j++) {
        swatches[j].classList.remove('is-active');
        swatches[j].setAttribute('aria-label', swatches[j].getAttribute('aria-label').replace(' (selected)', ''));
      }
      this.classList.add('is-active');
      this.setAttribute('aria-label', this.getAttribute('aria-label').replace(' (selected)', '') + ' (selected)');
    });
  }
})();
